"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimationHOC = exports.getAnimationEffectClassName = exports.defaultMarqueeLeftTime = void 0;
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var config_1 = require("./config");
// import './marquee.scss';
exports.defaultMarqueeLeftTime = 5;
exports.getAnimationEffectClassName = function (animateEffect) {
    switch (animateEffect) {
        case 'marquee':
            return "" + 'marquee';
        default:
            return animateEffect;
    }
};
// export const getAnimation = 
var AnimationWrapper = function (props) {
    var _a = props.marqueeLeftDuration, marqueeLeftDuration = _a === void 0 ? exports.defaultMarqueeLeftTime : _a, _b = props.animateEffect, animateEffect = _b === void 0 ? config_1.defaultAnimate : _b, _c = props.animationDelay, animationDelay = _c === void 0 ? config_1.defaultAnimationDelay : _c, _d = props.animationDuration, animationDuration = _d === void 0 ? config_1.defaultAnimationDuration : _d, children = props.children;
    var animationTime = animationDuration - animationDelay;
    return (react_1.default.createElement(core_1.Box, __assign({}, props, { style: {
            // animationDuration: `${animationTime}s`,
            // animationIterationCount: 'infinite',
            animationDelay: animationDelay + "s, " + marqueeLeftDuration + "s",
            animationFillMode: 'forwards',
            animationDuration: marqueeLeftDuration + "s, " + animationTime + "s",
        }, className: exports.getAnimationEffectClassName(animateEffect) }), children));
};
exports.AnimationHOC = function (Component) {
    return function (props) { return (react_1.default.createElement(AnimationWrapper, __assign({}, props),
        react_1.default.createElement(Component, __assign({}, props)))); };
};
exports.default = AnimationWrapper;
